<template>
    <div class="edit_home_div" v-if="sign_on">
        <div v-if="post_info.author.id == login_user_id">
            <SideBar></SideBar>
            <postEdit :post_info="post_info"></postEdit>
        </div>
        <div v-else>
            您不是作者，没有编辑权限！
        </div>
    </div>
    <div v-else>请先登录！
        <button @click="go_login">go</button>
    </div>
</template>

<script type="text/javascript">
    import SideBar from '@/components/posts_page/publish/publish_sidebar.vue'
    import postEdit from '@/components/posts_page/edit/post_edit.vue'
    import {mapState, mapActions} from 'vuex'

    export default {
        components: {
            SideBar,
            postEdit
        },
        methods: {
            ...mapActions({
                get_post_information: 'post/get_post_information',
                change_show_state: 'loginState/change_show_state',
            }),
            go_login() {
                this.change_show_state('on')
            },
        },
        computed: {
            ...mapState({
                post_info: state => state.post.post_information,
                login_user_id: state => state.loginState.user_info.id,
                sign_on: state => state.loginState.sign_on
            }),
        },
        mounted: function () {
            var postArgs = {'postId': this.$route.params.id};
            this.get_post_information(postArgs)
        }
    }
</script>
<style type="text/css">
</style>
